require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');


//////////////////
// WEBPACK FOOTER
// d:/documents/git/krkrsvchk/krkrsvchk_web/~/material-ui/~/babel-runtime/~/core-js/library/fn/get-iterator.js
// module id = 497
// module chunks = 1